// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    QUEER50_PAGE_LOADING() {
      return {
        isLoading: true,
        queer50: action.queer50
      };
    },
    QUEER50_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.queer50
      };
    },
    QUEER50_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.queer50.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
